import Settings from "./settings.service";
import Storage from "./storage.service";
// import { t } from "./translation.service";

const init = function() {
	window.dataLayer = [
		{
			breadcrumbs: ["Home"],
			language: "en-US",
			http_code: "200",
			customer_status: "not logged in",
			uid: 0,
			Unique_User_ID_session: "",
			Unique_User_ID_user: "",
		},
	];

	// Google Tag Manager
	(function(w, d, s, l, i) {
		w[l] = w[l] || [];
		w[l].push({
			"gtm.start": new Date().getTime(),
			event: "gtm.js",
		});
		var f = d.getElementsByTagName(s)[0],
			j = d.createElement(s),
			dl = l !== "dataLayer" ? "&l=" + l : "";
		j.async = true;
		j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
		j.onload = () => {};
		f.parentNode.insertBefore(j, f);
	})(window, document, "script", "dataLayer", Settings.gtm_container_id);
	// End Google Tag Manager
	// GTMService.onload();
};

const event = function(
	event,
	eventCategory,
	eventAction,
	eventLabel = "",
	eventValue = ""
) {
	window.dataLayer = window.dataLayer || [];
	let obj = {
		event: event,
		eventCategory: eventCategory,
		eventAction: eventAction,
		eventLabel: eventLabel ? eventLabel : "",
		eventValue: eventValue ? eventValue : "",
	};

	window.dataLayer.push(obj);
};

const event_with_callback = (
	event,
	eventCategory,
	eventAction,
	eventLabel = "",
	eventValue = "",
	callback
) => {
	window.dataLayer = window.dataLayer || [];
	let obj = {
		event: event,
		eventCategory: eventCategory,
		eventAction: eventAction,
		eventLabel: eventLabel ? eventLabel : "",
		eventValue: eventValue ? eventValue : "",
		eventCallback: function() {
			callback();
		},
		eventTimeout: 3000,
	};

	window.dataLayer.push(obj);
};

const pixel_event = (event, plan_selection_1, plan_selection_2, value) => {
	window.dataLayer = window.dataLayer || [];
	let obj = {
		event: event,
		plan_selection_l1: plan_selection_1,
		plan_selection_l2: plan_selection_2,
		value: value ? value : "",
	};
	window.dataLayer.push(obj);
};

const pixel_purchase_event = (
	event,
	plan_selection_1,
	plan_selection_2,
	value,
	transaction_id
) => {
	window.dataLayer = window.dataLayer || [];
	let obj = {
		event: event,
		plan_selection_l1: plan_selection_1,
		plan_selection_l2: plan_selection_2,
		value: value ? value : "",
		transaction_id: transaction_id ? transaction_id : null,
	};
	window.dataLayer.push(obj);
};

const impression = (impressionVal) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		ecommerce: {
			detail: {
				//actionField: {}
				products: [impressionVal],
			},
		},
	});
};

const dimension = (dimension, dimensionVal) => {
	window.dataLayer = window.dataLayer || [];
	let obj = {};
	obj[dimension] = dimensionVal;
	window.dataLayer.push(obj);
};

const metric = (metric, metricVal) => {
	window.dataLayer = window.dataLayer || [];
	let obj = {};
	obj[metric] = metricVal;
	window.dataLayer.push(obj);
};

const ecommerce = (
	transactionId,
	transactionTotal,
	SKU,
	name,
	impressions = null
) => {
	window.dataLayer = window.dataLayer || [];

	let obj = {
		transactionId: transactionId,
		transactionTotal: transactionTotal,
		//impressions: impressions,
		transactionProducts: [
			{
				sku: SKU,
				name: name,
				category: "1",
				price: transactionTotal,
				quantity: 1,
			},
		],
	};

	window.dataLayer.push(obj);
};

const findOrderIDforGTM = () => {
	let orderID = Storage.get("order_id");
	if (orderID) return orderID;

	let uid = Storage.get("account_id", true)? Storage.get("account_id", true).toLowerCase():'';
	let timestamp = Date.now();
  let prefix = Storage.get("paid_online", true) === true ? '' : "pod-"
	return Storage.get("selected_store_pickup", true)? `pis-${timestamp}-${uid}` : `${prefix}${timestamp}-${uid}`
}
const custom_event = (obj) => {
	const updatedObj = { ...obj };
	if ('cta_name' in updatedObj) {
			updatedObj['cta_name'] = updatedObj['cta_name'].toLowerCase();
	}
	window.dataLayer.push(updatedObj);
};

const GA4EcommercePurchase = (generalObj, subJourneyName, item_category2, item_name, selectedPlan ,itemIndex) => {
	// let selectedPlan = Storage.get("SelectedPlan");
	const valid_id_holder = Storage.get("valid_id_holder", true);
	const extraObj = {
			sub_journey_name: subJourneyName,
			custom_event_name: "purchase",
			ecommerce: {
				items :[
					{
						item_id: 'home internet',
						item_name: item_name,
						item_brand: "virgin mobile uae",
						index: itemIndex,
						discount : Storage.get("discountValue", true),
						item_category: "home internet",
						item_category2: item_category2,
						item_category3: `data: unlimited | speed: 5g`,
						item_category4: Storage.get("planDuration", true),
						price : selectedPlan?.PackagePrice?.NetPrice, 
						coupon : Storage.get('promo_code') ? Storage.get('promo_code') : '',
						item_list_name: "",
						item_list_id: "",
						quantity: 1,
					}
				], 
				customer_type: valid_id_holder === true ? "resident" : valid_id_holder === false ? "non resident" : "",
				payment_type: Storage.get('paid_online') === true ? "online" : '',
				coupon : Storage.get('promo_code') ? Storage.get('promo_code') : '',
				transaction_id : findOrderIDforGTM(),
				value : selectedPlan?.PackagePrice?.NetPrice,
				shipping : 0,
				currency: "aed",
				tax : selectedPlan?.PackagePrice?.VATAmount,
				shipping_tier : (!Storage.get("paid_online", true) && Storage.get("selected_store_pickup", true))? 'pick up from store':'delivery',
			}
	};

	const obj = { ...generalObj, ...extraObj };
	window.dataLayer.push(obj);
	Storage.set("eCommerceObj", JSON.stringify(obj), true);
};
const GA4VirtualPage = (generalObj, page_title, page_url) =>{
	const valid_id_holder = Storage.get("valid_id_holder", true);
	const uid = Storage.get("account_id", true) ? Storage.get("account_id", true).toLowerCase() : '';
	let extraObj = {
		page_title : page_title ? page_title : window.location.hash.replace(/[#/]/g, ''),
		page_url : page_url ? `${window.location.href.split("#")[0]}${page_url}`: window.location.href,
		uid : uid,
		useridCD : uid,
		customer_type: valid_id_holder === true ? "resident" : valid_id_holder === false ? "non resident" : "",
		login_status: Storage.get("account_id", true) ? 'logged in' : 'not logged in',
		registration_type: Storage.get("registration_type", true) ? (Storage.get("registration_type", true) === 'Email' ? 'email' : 'social') : '',
		hashedEmail: Storage.get("hashed_email_address", true)? Storage.get("hashed_email_address", true) : '',
		account_id: Storage.get("account_id", true) ? Storage.get("account_id", true).toLowerCase() : '',
	}
	const obj = { ...generalObj, ...extraObj };
	window.dataLayer.push(obj);
	Storage.set("eCommerceObj", JSON.stringify(obj), true);
}
const generalEvent = (options = {}) => {
	const {
			eventType = 'custom_event',
			eventCustomName,
			page_title,
			page_url,
			extra_obj,
			itemIndex = 1,
			deviceName
	} = options;

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer = window.dataLayer || [];

	const subJourney = deviceName ? 1 : 0;
	
	const sub_journey_array = [`data + without router`, `data + router`];
	const item_name_array = ['unlimited 5g without router', `unlimited 5g with ${deviceName}`];
	const selectedPlan = Storage.get("SelectedPlan");
	const sub_journey_name = sub_journey_array[subJourney];
	const item_name = item_name_array[subJourney];
	const item_category2 = sub_journey_array[subJourney];

	const generalObj = {
			event: eventType  === 'virtualPageView' ? "virtualPageView" :  "eventTracker",
			journey_name: "home internet plan",
			custom_event_name: eventCustomName,
	};

	if (eventType === 'custom_event') {
			custom_event({ ...generalObj, ...extra_obj });
	} else if (eventType === 'ecommerce_event')  {
			GA4Ecommerce(generalObj, item_category2, item_name, sub_journey_name, itemIndex, selectedPlan);
	} else if (eventType === 'ecommerce_purchase') {
			GA4EcommercePurchase(generalObj, sub_journey_name, item_category2,item_name, selectedPlan, itemIndex);
	} else if (eventType === 'virtualPageView'){
		GA4VirtualPage(generalObj, page_title ,page_url)
	}
};

const GA4Ecommerce = (generalObj, item_category2, item_name, sub_journey_name, itemIndex, selectedPlan) => {
	let discountValue = Storage.get("discountValue", true); 
	const valid_id_holder = Storage.get("valid_id_holder", true);
	const extraObj = {
			sub_journey_name: sub_journey_name,
			ecommerce: {
					items: [
							{
									item_id: 'home internet',
									item_name: item_name,
									item_brand: "virgin mobile uae",
									index: itemIndex,
									coupon: Storage.get('promo_code', true) ? Storage.get('promo_code', true) : '',
									item_category: "home internet",
									item_category2: item_category2,
									item_category3: `data: unlimited | speed: 5g`,
									item_category4: Storage.get("planDuration", true),
									item_list_name: "",
									item_list_id: "",
									discount: discountValue ? discountValue : 0,
									price: selectedPlan?.PackagePrice.NetPrice,
									quantity: 1
							}
					],
					customer_type: valid_id_holder === true ? "resident" : valid_id_holder === false ? "non resident" : "",
			}
	};
	if (Storage.get('payment_type')) {
  	extraObj.ecommerce.payment_type = Storage.get('payment_type');
}
	const obj = { ...generalObj, ...extraObj };
	window.dataLayer.push(obj);
	Storage.set("eCommerceObj", JSON.stringify(obj), true);
};
const activeABTestEvent = (variableName, experience_name, variation_name) => {
	if(window[variableName]){
			let obj = {
					event: "eventTracker",
					journey_name: "home internet",
					custom_event_name: 'active ab test',
					experience_name : experience_name.toLowerCase(),
					variant_name : window[variableName] === true ? variation_name.toLowerCase() : 'original',
			};
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(obj);
	}
}
export {
	metric,
	dimension,
	event,
	impression,
	init,
	ecommerce,
	event_with_callback,
	pixel_event,
	pixel_purchase_event,
	generalEvent,
	activeABTestEvent,
	GA4Ecommerce
};
